import { createSlice } from '@reduxjs/toolkit'

import {
  getCurrentUser,
  login,
  signUp,
  validateCredentials,
} from '../actions/authActions'

interface UserState {
  user: {
    access_token: string | null
    data: User | null
  }
  loading: boolean
  error: boolean
  registrationSuccess: boolean
  loginSuccess: boolean
  validateSuccess: boolean
}

const initialState: UserState = {
  user: {
    access_token: null,
    data: null,
  },
  loading: false,
  error: false,
  registrationSuccess: false,
  loginSuccess: false,
  validateSuccess: false,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signOutUser: (state) => {
      state.user.access_token = null
      state.user.data = null
    },
    updateToken: (state, action) => {
      state.user.access_token = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.user.access_token = action.payload?.access_token
        state.loading = false
        state.loginSuccess = true
      })
      .addCase(login.pending, (state) => {
        state.user.access_token = null
        state.loading = true
        state.error = false
        state.loginSuccess = false
      })
      .addCase(login.rejected, (state) => {
        state.user.access_token = null
        state.error = true
        state.loading = false
        state.loginSuccess = false
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.user.access_token = action.payload.access_token
        state.loading = false
        state.error = false
        state.registrationSuccess = true
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true
        state.error = false
        state.registrationSuccess = false
      })
      .addCase(signUp.rejected, (state) => {
        state.loading = false
        state.error = true
        state.registrationSuccess = false
      })
      .addCase(validateCredentials.fulfilled, (state) => {
        state.loading = false
        state.error = false
        state.validateSuccess = true
      })
      .addCase(validateCredentials.pending, (state) => {
        state.loading = true
        state.error = false
        state.validateSuccess = false
      })
      .addCase(validateCredentials.rejected, (state) => {
        state.loading = false
        state.error = true
        state.validateSuccess = false
      })
      .addCase(getCurrentUser.fulfilled, (state, action) => {
        state.user.data = action.payload
        state.loading = false
        state.loginSuccess = true
      })
      .addCase(getCurrentUser.pending, (state) => {
        state.loading = true
        state.error = false
      })
      .addCase(getCurrentUser.rejected, (state) => {
        state.error = true
        state.loading = false
        state.validateSuccess = false
        state.loginSuccess = false
      })
  },
})

export const { signOutUser, updateToken } = userSlice.actions

export default userSlice.reducer
